import * as tasks from './tasks.js'

export default {
  tasks
}
